module.exports = {
    type: 'Questão aberta',
    instruction: 'Digite abaixo o enunciado da questão. O estudante deverá digitar a resposta em formato de texto.',
    typeHere: 'Digite aqui...',
}